import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import Pagination from 'src/components/atoms/pagination/pagination';
import Spinner from 'src/components/atoms/spinner/spinner';
import Table from 'src/components/atoms/table/table';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { openModal } from 'src/reducers/modal.reducer';
import { getRoles } from 'src/reducers/roles.reducer';
import { getParamsFromUrl, rolesDefaultParams, setParamsToUrl } from '../../../utils/pagination-utils';
import { Icon } from '../../atoms/icon';
import { ProfileTableCard } from './profiles-and-authorization-table/profiles-table-card';
import { ProfileTableHeader } from './profiles-and-authorization-table/profiles-table-header';
import { ProfilesAndAuthorizationsCreate } from './profiles-and-authorizations-modals/profilesAndAuthorizationsCreate';
import styles from './profiles-and-authorizations.module.scss';

const ProfilesAndAuthorizations = () => {
  const dispatch = useAppDispatch();
  const { fetchLoading, fetchFailure, fetchSuccess, roles, refresh, totalItems } = useAppSelector(state => state.roles);
  const navigate = useNavigate();
  const location = useLocation();

  const [params, setParams] = useState(getParamsFromUrl(rolesDefaultParams, location));

  const createNewRole = () => {
    dispatch(
      openModal({
        children: <ProfilesAndAuthorizationsCreate />,
        opt: {
          size: 'xs',
          type: 'default',
          title: 'Crea nuovo profilo',
        },
      })
    );
  };

  const handlePagination = (page: number) => {
    setParams(prevState => ({
      ...prevState,
      currentPage: page + 1,
    }));
  };

  useEffect(() => {
    dispatch(getRoles({ pagination: params }));
    setParamsToUrl(params, navigate);
  }, [dispatch, params.currentPage, params.sortBy, params.sortDirection, refresh]);

  if (fetchLoading) {
    return <Spinner className={styles.spinner} />;
  }

  return (
    <div className={styles.profilesContainer}>
      <div className={styles.contentWrapper}>
        {!fetchLoading && fetchFailure && <div className="m-1">Errore nel caricamento dei profili e delle autorizzazioni.</div>}
        {!fetchLoading && fetchSuccess && roles?.length === 0 && <div className="m-1">Nessun ruolo trovato.</div>}
        {!fetchLoading && fetchSuccess && roles?.length > 0 && (
          <>
            <Table>
              <Table.Header>
                <ProfileTableHeader />
              </Table.Header>
              <Table.Body>
                {roles?.map(roleWithCapabilities => (
                  <ProfileTableCard roleWithCapabilities={roleWithCapabilities} key={roleWithCapabilities.role.id} />
                ))}
              </Table.Body>
            </Table>
            <Pagination
              activePage={params.currentPage - 1}
              itemsPerPage={params.postPerPage}
              totalItems={totalItems || 0}
              paginate={handlePagination}
            />
          </>
        )}
        <Button className={styles.addButtonSticky} color="black" mode="solid" size="md" circle onClick={createNewRole}>
          <Icon content="add" size="sm" color="white" />
        </Button>
      </div>
    </div>
  );
};

export default ProfilesAndAuthorizations;
